import React from "react";
import { Breath, Footer, Podcast } from "../components";

const Audio = () => {
  return (
    <>
      <Podcast />
      <Breath />
      <Footer />
    </>
  );
};

export default Audio;
